import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import BluedotTech from "@bluedot-tech/vue-ui";
import "@bluedot-tech/vue-ui/es/style/global.less";
import { customLocalStorage, monitor } from "@bluedot-tech/vue-ui/es/plugins";
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import loading from '@/utils/loading';
import config from './config/config';

import './utils/axiosConfig';

Vue.config.productionTip = false;

Vue.use(BluedotTech);
Vue.use(customLocalStorage, {
  prefix: config.storagePrefix,
});
Vue.use(monitor, {
  monitor: config.monitor,
  appid: config.appid,
});

// 全局的loading弹层绑定
Vue.use(loading);

Vue.use(Vant);

// axios请求绑定到prototype上
Vue.use(VueAxios, axios);

import mixin from '@/mixins';
Vue.mixin(mixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');